/*
 * Created by Anup Shrestha (anup.stha012@gmail.com)
 * Copyright (c) 2022.  All rights reserved.
 * Last modified 5/11/22, 3:18 PM
 *
 */

import { useQuery } from 'react-query';

import { getMemberTestList } from 'features/members/api/requests/member.request';

export const useMemberTestList = (
  memberId: number,
  testCategoryId: number,
  pageNumber?: number
) => {
  return useQuery(
    ['member-test-list', memberId, testCategoryId, pageNumber],
    () => getMemberTestList(memberId, testCategoryId, pageNumber),
    {
      enabled: !!memberId && !!testCategoryId,
    }
  );
};
